// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/css/application.scss
 ** module id = 1
 ** module chunks = 0
 **/